export const EN_EEUU = {
    message: {
        loginComponent: {
            login: {
                logintext: 'Login',
                loadingtext: 'Loading',
                forgetPassword: 'Forget password?',
            },
            forgetPassword: {
                goBack: 'Go Back',
                send: 'Send',
            },
            firstLogin: {
                firstLoginText: 'First Login',
                changePassSecurity: 'For security reasons you must change your login password',
                rememberValidMail: 'Remember to enter a valid email, it will be verified during the process',
                goBack: 'Go Back',
                send: 'Send',
                success: 'Password updated successfully'
            },
            blockedUser: {
                title: "User blocked",
                msg_1: "Por motivos de seguridad se ha bloqueado su usuario. Te hemos enviado un correo electrónico para ofrecerle 5 nuevos intentos para recuperar su contraseña sin tener que modificarla. Por favor siga las instrucciones del correo electrónico para poder desbloquear su cuenta. En caso de no tener un correo electrónico registrado, contactarse con RRHH de su empresa.",
                msg_2: "Detectamos que no has podido recuperar tu contraseña.Te hemos enviado un correo electrónico con las instrucciones para la generación de la nueva contraseña."
            },
            unblockedUser: {
                title: "User unblocked successfully",
                msg_1: "Su usuario se ha desbloqueado con éxito. Por favor intente nuevamente ingresar a la plataforma."

            },
            validations: {
                emailRules: {
                    requireMail: 'The email is required',
                    validMail: 'The email must be valid',
                },
                userRules: {
                    requireUser: 'The user is required',
                    requireLessCharactersUser: 'The user must have less than 10 characters',
                },
                passwordRules: {
                    requirePass: 'The password is required',
                    requireMoreCharactersPass: 'The password must have more than 4 characters',
                }
            },
            languagesVuetify: {
                languages: 'Language',
                user: 'User',
                password: 'Password',
                mail: 'Email',
            },
        },
        menuComponent: {
            item0: "Home",
            item1: "Documents",
            item2: "Licenses",
            item3: "Settings"
        },
        HeaderComponent: {
            logout: {
                wantLogOutText: 'Are you sure you want to logout?',
                no: 'No',
                yes: 'Yes',
            }
        },
        DocumentsComponents: {
            title: 'Documents'
        },
        Errors: {
            404: {
                title_404: 'Lo sentimos, pero la pagina no fue encontrada',
                sub_title_404: 'Afortunadamente usted puede volver a buscar en el home',
            },
        },
        errorReference: {
            "00015": "First login is required.",
            "00017": "Bad Request.",
            "00001": "Incorrect user or password.",
            "00018": "User is locked.",
            "00019": "The password entered does not comply with security policies",
            "00020": "Invalid token.",
            "00016": "First login already done.",
            "00021": "Token generation failed",
            "00022": "Token registration failed.",
            "00026": "Password was previously used",
            "00069": "Enter the password, required to update the data",
            "00070": "The email box to update has not been defined",
            "00071": "Incorrect password",
            "00072": "The user has not been identified",
            "00073": "You do not have permissions to modify the user",
            "00074": "Mail incorrect"
        },
        settingsComponent: {
            header: {
                upload: "Upload image",
                change: "Change image",
                cropImage: "Crop image",
                exitEditMode: "Save changes",
                saveChanges: "Upload",
                cropSuccess: "Profile picture changed successfully"
            },
            list: {
                changePassword: {
                    title: "Change password",
                    dialogTitle: "Edit password",
                    labelOldPass: "Actual password",
                    labelPass: "New password",
                    labelRePass: "Repeat password",
                    samePassValidation: "Passwords are not equals",
                    success: "Password changed successfully"
                },
                changeEmail: {
                    title: "Change email"
                },
                switchCompany: {
                    title: "Switch company",
                    success: "Cpmpany switched successfully",
                    actionChangeCompany: 'Change',
                    stateCurrentCompany: 'Current'
                },
                buttonCancel: "Cancel",
                buttonSave: "Save",
                okMsg: "Ok",
                logOut: "Logout"
            },
            footer: {
                help: "Help",
                contact: "Contact"
            }
        }
    },
    dialect: 'EN'
};